import React from 'react';
import SbEditable from 'storyblok-react';

import './iconset-widget.scss';

const IconsetWidget = (props) => {
  const textProps = ['iconset-text'];
  if (props.blok.theme) {
    textProps.push('theme-' + props.blok.theme);
  }

  return (
    <SbEditable content={props.blok}>
      <div className="iconset-widget">
        <img src={props.blok.image.filename} alt={props.blok.title} />
        <div className={textProps.join(' ')}>
          <h5>{props.blok.title}</h5>
          <p>{props.blok.text}</p>
        </div>
      </div>
    </SbEditable>
  );
};

export default IconsetWidget;
